<template>
  <div id="share__container" :class="[{left: mode === 'left', right: mode === 'right'}]" >
    <img src="@/assets/icon/bg_box_left.png" class="background-image" alt="" v-if="mode === 'left'">
    <img src="@/assets/icon/bg_box_right.png" class="background-image" alt="" v-else>
    <div class="icon__container">
      <div class="icon__contents" @click.stop="copy(clipboardText)">
        <div class="icon copylink">
          <img src="@/assets/icon/icon_copylink.png" alt="" />
        </div>
      </div>
      <div class="line"></div>
      <div class="icon__contents" id="kakaoLink" @click.stop>
        <div class="icon kakao" >
          <img src="@/assets/icon/icon_kakao.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ShareComponent',
  props: {
    clipboardText: {
      default: '',
      type: String
    },
    mode: {
      default: 'left',
      type: String
    },
    kakaoSendInfo: {}
  },
  watch: {
    kakaoSendInfo: {
      deep: true,
      handler () {
        const {name, imageUrl, sellPrice} = this.kakaoSendInfo
        window.Kakao.Link.createDefaultButton({
          container: '#kakaoLink',
          objectType: 'feed',
          content: {
            title: '행사할 땐 세리해요!',
            description: `상품명: ${name}\n행사가: ${sellPrice}`,
            imageUrl: `${imageUrl}`,
            link: {
              mobileWebUrl: 'https://play.google.com/store/apps/details?id=com.tonovation.tery',
              webUrl: this.clipboardText
            }
          }
          // social: {
          //   likeCount: 9999,
          //   commentCount: 9999,
          //   sharedCount: 30,
          // },
        })
      }
    }
  },
  data () {
    return {

    }
  },
  mounted () {},
  methods: {
    copy (msg) {
      const textarea = document.createElement('textarea')
      textarea.value = msg
      document.body.appendChild(textarea)
      textarea.select()
      textarea.setSelectionRange(0, 9999)
      document.execCommand('copy')
      document.body.removeChild(textarea)
      alert('복사되었습니다.')
      this.$emit('closeShareComponent')
    },
    test () {
      console.log('thois')
    }
  }
}
</script>
<style scoped lang="scss">
#share__container {
  width: 180px;
  height: 90px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  .background-image {
    position: absolute;
  }
  .icon__container {
    margin-top: -25px;
    .icon__contents {
      display: inline-block;
      width: 70px;
      position: relative;
      & .icon {
        &::after {
          position: absolute;
          font-family: Noto Sans KR;
          font-style: normal;
          font-weight: 500;
          font-size: 12px;
          line-height: 17px;
          text-align: center;
          color: #858585;
          bottom: -20px;
          left: 50%;
          transform: translateX(-50%);
          width: 100%;
        }
        &.copylink {
          &::after {
            content: "링크복사";
          }
        }
        &.kakao {
          &::after {
            content: "카카오";
          }
        }
      }
    }
    .line {
      position: relative;
      width: 0;
      height: 20px;
      border: 1px solid #e4e4e4;
      display: inline-block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shareComponent/index.vue